import { APIClient } from "../../../../api/api_helper";
import { GetUserData } from "../../../../common/service/CommonService";
import { Admin_API } from "../../../../api/url_helper";
import { InsertRightsPayload } from "modules/Library/Role/api/useRightsQuery";
/* ------------------------------------------------------------------
 * TYPES
 * ------------------------------------------------------------------ */

interface CurrentUser {
  userid: number;

}

type RolePayload = object;

/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();

/* ------------------------------------------------------------------
 * ROLE API
 * ------------------------------------------------------------------ */

export const rightsApiService = {

  // SELECT ALL METHOD
  getSelectAllData: (searchText?: string | null) => {
    const payload = {
      status: "A",
      searchtext: searchText || null,
    };
    return api.create(Admin_API.Rights_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (id: number | undefined | null) => {
    const payload = {
      roleid: id
    };
    return api.create(Admin_API.Rights_API + "Select", payload);
  },

  // INSERT METHOD
  insertRoleRights: (payload_data: InsertRightsPayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      createdby: user.userid,
      updatedby: user.userid,
    };
    return api.create(Admin_API.Rights_API + "Insert", payload);
  },

  // UPDATE METHOD
  updateData: (payload_data: RolePayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      updatedby: user.userid,
    };
    return api.create(Admin_API.Rights_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: { id: number | null; updatereason: string; }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      roleid: payload_data.id,
      updatereason: payload_data.updatereason,
      updatedby: user.userid
    };
    return api.create(Admin_API.Rights_API + "Delete", payload);
  },
};


